// extracted by mini-css-extract-plugin
export default {"img":"Avatar_img__iHyT+","fallback":"Avatar_fallback__SmJSu"};